import styled from 'styled-components'

export const DownloadButtonStyled = styled.a`
  background-color: ${({ theme }) => theme.colors.primaryLighter};
  color: ${({ theme }) => theme.colors.dark};
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.button};
  padding: 10px 20px;
  font-weight: bold;
  font-size: 1rem;
  transition: 0.5s;
  cursor: pointer;
  text-align: center;
  text-decoration: none;

  &:hover {
    background-color: ${({ theme }) => theme.colors.primary};
  }
`
